(() => {
  document.querySelectorAll('[data-lyckd-ingredients]').forEach((gallery) => {
    const track = gallery.querySelector('.lyckd-ingredients__track');
    const controls = gallery.querySelector('.lyckd-ingredients__controls');
    const previous = gallery.querySelector('[data-direction="previous"]');
    const next = gallery.querySelector('[data-direction="next"]');

    function updateControls() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      controls.hidden = maxScroll <= 2;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function move(direction) {
      const card = track.querySelector('.lyckd-ingredients__card');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    new ResizeObserver(updateControls).observe(track);
    updateControls();
  });
})();
